import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom/cjs/react-router-dom.min";


class TwilioText extends Component {
  constructor(props) {
    super(props)
   
  }



  render() {
   const {userdetail} = this.props;

    return (
      <React.Fragment>
            <div className="d-none d-md-block ms-2">
           {userdetail?.twilioSMSNumber ?  <h6 style={{lineHeight:'70px', fontWeight:'bold'}}><span className="badge bg-warning text-dark" style={{padding:10, fontSize:14}}>SMS # : {userdetail?.twilioSMSNumber}</span></h6> : '' }
           </div>
      </React.Fragment>
    )
  }
}
TwilioText.propTypes = {
  userdetail:PropTypes.object
}
export default withTranslation()(TwilioText);
